export const constants = {
  'Late installments': 'Parcelas atrasadas',
  'Next installment {{date}}': 'Próxima parcela {{date}}',
  Paid_installments: 'Quitadas',
};
